module.exports = __webpack_public_path__ + "1b3d66b8faeb7a29f43dc6dc191f098d.svg";